import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { Email } from 'app/models/questions/Email'
import { AbstractControl } from '@angular/forms'
import { SurveyViewerService } from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import {AuthService} from "../../../../../../core/auth/auth.service";
import {UserService} from "../../../../../../core/user/user.service";

@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailComponent implements IQuestionComponent, OnInit {

  @Input() activeLang: string
  @Input() isSmallScreen: boolean
  @Input() question: Email

  questionFormControl: AbstractControl
  createUserOnSubmit = true;

  constructor(
    public surveyViewerService: SurveyViewerService,
    public authService: AuthService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form
      .get(this.question.key)
      .get(this.question.rowKeys.pop())
      .get(this.question.commentsControlName)
      .get(this.question.emailFormControlName)
    // this.questionFormControl.addAsyncValidators(this.surveyViewerService.userExistValidator(!!this.question.createUser))
    if (this.authService.isLogged()){
      this.questionFormControl.patchValue(this.userService.user.email)
    }
    this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl, 'blur');

  }

}
